import React, { Dispatch, FC } from 'react';

import { TableStyled } from 'ui/table.styled';
import { IColumnSortingInfo, ITableColumn } from 'types/table';
import { useTableHook } from 'hooks/useTable';
import { TableHeader } from './table-header';
import { TableContent } from './table-content';

interface ITableProps {
  isLoading: boolean;
  columns: ITableColumn[];
  data: Record<string, unknown>[];
  columnsSorting?: IColumnSortingInfo[];
  sortColumnData?: Dispatch<IColumnSortingInfo>;
}

export const Table: FC<ITableProps> = (props) => {
  const { headerProps, contentProps, getTableProps } = useTableHook(props);

  return (
    <TableStyled {...getTableProps()}>
      <TableHeader {...headerProps} />
      <TableContent {...contentProps} />
    </TableStyled>
  );
};
